export enum FragmentType {
    OrderBy = 1,
    Top = 2,
    Skip = 3,
    Count = 4,
    Expand = 5,
    Filter = 6,
    Select = 7
  }
